import { cartLinesStyles } from "@insite/content-library/Widgets/Cart/CartLines";
import { css } from "styled-components";

cartLinesStyles.header = {
    condensedViewCheckboxGroup: {
        css: css`
            visibility: hidden;
            margin-left: auto;
        `,
    },
    warningIcon: {
        src: "AlertCircle",
        color: "danger.main",
        css: css`
            margin-right: 10px;
            background: #008061;
            border-radius: 50%;
            padding: 2px;
            height: 16px;
            width: 16px;
            svg {
                height: 12px;
                width: 12px;
                color: #fff;
            }
        `,
    },
};
